<template>
  <div id="app">
    <div class="wrapper">
      <AppMenu v-if="$parent.usuario !== null" :usuario="$parent.usuario"/>
      <AppMenuOpcion :menu="$parent.menu" :chat="$parent.chat"/>

      
      <div class="content-wrapper navbar-white" v-if="$parent.usuario !== null">
        <section class="content">
          <div class="container-fluid">
            <router-view></router-view>
            <footer class="main-footer">
            </footer>
          </div>
        </section>
      </div>
      <div v-else class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import AppMenu from './components/AppMenu.vue';
  import AppMenuOpcion from './components/AppMenuOpcion.vue';

  export default {
    name: 'App',
    components: {
      AppMenu,
      AppMenuOpcion
    }
  }
</script>